// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__MZIeA","light":"Tooltip_light__GcPn5","small":"Tooltip_small__LDnLa"};